var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('Navbar'),_c('v-main',{staticClass:"sea_light_blue"},[_c('v-container',{staticClass:"my-5",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }